<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import ColorBoxes from '@/src/components/color-boxes.vue'
import PopOver from '@/src/components/pop-over.vue'

export default {
  page: {
    title: 'Style Guide',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, ColorBoxes, PopOver },
  methods: {},
}
</script>

<template>
  <Layout class="p-l-15 p-r-15">
    <h2>Typography</h2>
    <h1>H1 - Hexagon Akkurat Bold</h1>
    <h2>H2 - Hexagon Akkurat Bold - 25pt</h2>
    <h3>H3 - Hexagon Akkurat Regular - 20pt</h3>
    <h4>H4 - Hexagon Akkurat Black - 15pt all caps</h4>
    <h5>H5 - hexagon akkurat bold - 12pt</h5>
    <h6>H6 - Hexagon akkurat - 16pt</h6>
    <p>Paragraph - Open Sans Regular - 15pt</p>
    <hr />
    <h2>Color pallets</h2>
    <div class="flex flexRow">
      <ColorBoxes color="Primary"></ColorBoxes>
      <ColorBoxes color="PrimaryLighter"></ColorBoxes>
      <ColorBoxes color="PrimaryDarker"></ColorBoxes>
      <ColorBoxes color="White"></ColorBoxes>
      <ColorBoxes color="Orange"></ColorBoxes>
    </div>
    <hr />
    <h2>Buttons</h2>
    <div class="flex flexRow">
      <BaseButton class="m-r-15 m-t-0 m-b-0">
        Default Button
      </BaseButton>
      <BaseButtonAngle clip-side="Right">
        Drill &amp; blast OVERVIEW
      </BaseButtonAngle>
    </div>
    <hr />
    <h2>Hotspots</h2>
    <div class="flex flexRow flexAlEnd">
      <BaseHotspot class="m-r-15" spot-size="large" />
      <BaseHotspot class="m-r-15" />
      <BaseHotspot class="m-r-15" spot-active="inactive" />
      <BaseIndicator />
    </div>

    <h2>Content Boxes</h2>
    <div class="flex flexRow flexAlEnd">
      <PopOver
        title="Testing Title"
        pop-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vulputate, quis varius ligula dui et velit. Sed hendrerit cursus odio, vitae tempor erat ultrices ut. Maecenas eu est a purus ornare congue a vitae arcu. Suspendisse nec nibh a arcu condimentum laoreet facilisis a orci. Maecenas quis porta purus. Ut ac pellentesque ligula, venenatis elementum libero. Morbi facilisis tristique risus, sed fringilla nisi commodo a. "
        pop-size="md"
        pop-height="300px"
      >
      </PopOver>
    </div>
  </Layout>
</template>
